export function createAnimationFrameScheduler() {
  let frame: number | null = null
  let latestCallback: ((...args: unknown[]) => void) | null = null
  let latestArgs: unknown[] = []

  const schedule = <T extends unknown[]>(cb: (...args: T) => void, ...args: T) => {
    latestCallback = cb as (...args: unknown[]) => void
    latestArgs = args

    if (frame !== null) {
      cancelAnimationFrame(frame)
    }

    frame = requestAnimationFrame(() => {
      if (latestCallback) {
        latestCallback(...latestArgs)
      }
      frame = null
    })
  }

  const cancel = () => {
    if (frame !== null) {
      cancelAnimationFrame(frame)
      frame = null
    }
  }

  return { schedule, cancel }
}
